<template>
<font class="mount"></font>
</template>

<script>
import * as nav from "navigation.js"
import {notifyError} from "common.js"
import {markRaw} from "vue"

export default {
  name: "RadixModule",
  
  props: {
    path: String,
    state: Object,
  },
  
  data() {
    return {
      module: null,
    }
  },
  
  expose: [ "invoke" ],

  mounted()
  {
    const mountPoint = this.$el

    nav.promiseModule(this.path, mountPoint, {})
    .then(mod =>
    {
      this.module = markRaw(mod)
      this.module.setState(Object.assign({}, this.state))
    })
    .catch(err => {
      notifyError("RadixModule: "+err)
      console.log(err)
    })
  },
  
  methods: {
    invoke(method, ...args)
    {
      const fun = this.module[method]
      if (fun && typeof fun == "function")
      {
        this.module[method].apply(this.module, args)
      }
      else
      {
        notifyError(`RadixModule: в модуле ${this.module.name} нет функции ${method}`)
      }
    },
  },
  
  watch: {
    state(val)
    {
      if (this.module) this.module.setState(Object.assign ({}, val))
    },
  },
}
</script>
